import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData,
  type UploadImageV1PortfoliosPortfolioIdAssetsImagesPostError,
  type UploadImageV1PortfoliosPortfolioIdAssetsImagesPostResponse,
  uploadImageV1PortfoliosPortfolioIdAssetsImagesPost,
} from '../../generated';

export type UploadImageMutationVariables = UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData['path'] &
  UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData['body'];

export type UploadImageMutation = UploadImageV1PortfoliosPortfolioIdAssetsImagesPostResponse;

export const useUploadImageMutation = <
  TError = UploadImageV1PortfoliosPortfolioIdAssetsImagesPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<UploadImageMutation, TError, UploadImageMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<UploadImageMutation, TError, UploadImageMutationVariables, TContext>({
    mutationKey: ['UploadImage'],
    mutationFn: async ({ portfolio_id, ...body }: UploadImageMutationVariables) => {
      const { data } = await uploadImageV1PortfoliosPortfolioIdAssetsImagesPost({
        path: { portfolio_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useUploadImageMutation.fetcher = (
  { portfolio_id, ...body }: UploadImageMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await uploadImageV1PortfoliosPortfolioIdAssetsImagesPost({
      path: { portfolio_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
